import React, { useEffect, useState } from 'react'
import { Badge, Container } from 'react-bootstrap'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomTable from '../Components/CustomTable/CustomTable'
import { useNavigate } from 'react-router-dom'
import { deleteNote, fetchNotes } from '../hooks/notes'
import { useDispatch, useSelector } from 'react-redux'
import CustomViewImage from '../Components/CustomViewImage/CustomViewImage'
import CustomModal from '../Components/CustomModal/CustomModal'

function StudentsNotes() {
  const navigate = useNavigate();
    const dispatch=useDispatch();
              const [sourceImg, setSourceImg] = useState(null)
                const [modalShow, setModalShow] = useState(false);
      const [deleteShowModal, setDeleteShowModal] = useState(false);
      const [itemID, setItemID] = useState(null)
    
          const  {list}  = useSelector((state) => state.notes);
const formatToOman = (dateString) => {
  const date = new Date(dateString);

  return {
    date: date.toLocaleDateString("en-OM", {
      timeZone: "Asia/Muscat",
    }),
    time: date.toLocaleTimeString("en-OM", {
      timeZone: "Asia/Muscat",
      hour: "2-digit",
      minute: "2-digit",
    }),
  };
};

  
      useEffect(() => {
        dispatch(fetchNotes())
        }, [dispatch])
  const customheader=<thead>
    <tr>
      
      <td><strong>الصورة</strong></td>
      <td><strong>اسم الوجبة</strong></td>
      <td><strong>تعليقي</strong></td>
      <td><strong>التاريخ</strong></td>
      <td><strong>الوقت</strong></td>
      <td></td>

    </tr>
  </thead>

  const body=<tbody>
          {list?.map((item)=>{
                const formatted = formatToOman(item?.created_at);

return(
    <tr>
  <td><img src={item?.image}alt=''className='w-25' onClick={(e)=>{
              setSourceImg(item?.image)
              setModalShow(true)
            }}/></td>
                  <td>{item?.category?.name}</td>
      <td>{item?.note}</td>
        <td>{formatted.date}</td>
        <td>{formatted.time}</td>

            <td><Badge bg='danger'
          onClick={()=>{
            setItemID(item?.id)
            setDeleteShowModal(true)
          }}
          >مسح </Badge></td>

    </tr>
)
          })}

  </tbody>
const deleteItem=()=>{
      dispatch(deleteNote(itemID))
        .unwrap() // Allows us to use .then() / .catch() on the thunk result
        .then(() => {
  dispatch(fetchNotes())
          alert(`تم المسح الملاحظة بنجاح`);
setDeleteShowModal(false)
          
        })
        .catch((err) => {
          // Error is already handled in Redux, but you can do specific UI logic here
          console.error("Failed to save:", err);
        });
  
}
  return (
    <div>
            <CustomViewImage
              show={modalShow}
              onHide={() => setModalShow(false)}
              src={sourceImg}
            />
                            <CustomModal show={deleteShowModal} onHide={() => setDeleteShowModal(false)}ar_status={'الملاحظة'} deleteItem={deleteItem}/>

    <AuthNavbar/>
      <Container>

                <CustomHeader
          title={"الالتحاق بالأكاديمية"}
          subtitle={"إدارة  مستفيدين نشطًا في برامج فنون الطهي"}
          downloadData={false}
          addData={true}
                    status={"student-notes"}


        />
                <CustomTable
          fiteration={[]}
          currentData={25}
          allData={' 1,248  مستفيد'}
          customheader={customheader}
          status={"student"}
          body={body}

        />
        </Container>
    </div>
  )
}

export default StudentsNotes
